/* tslint:disable:no-empty */
export function noop() { }
//# sourceMappingURL=noop.js.map